export default {
  'primary': '#0e6c3c',
  'secondary': '#6C9CEA'
}
